<template> 
 <div class="animated fadeIn">
            <b-overlay :show="loading" rounded="sm">
                
                <b-card
                    header="Configuration Settings"
                    header-text-variant="light"
                    header-tag="header"
                    header-class="header-color"
                >
                <b-table-simple v-if="kioskConfigList.length != 0 && editConfigLoading === false"  striped borderless responsive>
                        <b-thead>
                            <b-tr class="bg-gray-300">
                                <b-th>Asset Category</b-th>
                                <b-th>Asset Name</b-th>
                                <b-th>Display Theme</b-th>
                                <b-th>Bootup Display Mode</b-th>
                                <b-th>Available Display Modes</b-th>
                                <b-th>Auto Scroll</b-th>
                                <b-th>Show Price</b-th>
                                <b-th>Item Description</b-th>
                                <b-th>Ordering Buttons</b-th>
                                <b-th>Banners</b-th>
                                <b-th>Disruptive Ads</b-th>
                                <b-th>Widgets</b-th>
                                <b-th></b-th>
                                
                                

                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item,index) in kioskConfigList" :key="index" @click="showEditConfigMode(item)">
                                <b-td>
                                    <span> {{ item.AssetCategory }}</span>
                                </b-td>
                                <b-td>
                                    <span> {{ item.AssetName }}</span> <span class="text-muted" style="font-size: 0.75rem;">{{'(ID:' + item.KioskID +')'}}</span>
                                </b-td>
                                <b-td>
                                    <span> {{ item.Theme }}</span>
                                </b-td>
                                <b-td>
                                    <span> {{ item.BootupDisplayMode }}</span>
                                </b-td>
                                <b-td>
                                    <span> {{ item.AvailableDisplayModes }}</span>
                                </b-td>
                                <b-td>
                                    <span v-if="item.ItemForShow === 'Food'"> Food Menu</span>
                                    <span v-else-if="item.ItemForShow === 'Drink'"> Drink Menu</span>
                                    <span v-else-if="item.ItemForShow === 'Food & Drink'"> Food & Drink Menu</span>
                                    <span v-else> None</span>
                                </b-td>
                                <b-td>
                                    <span> {{ pritify(item.ShowPrice) }}</span>
                                </b-td>
                                <b-td>
                                    <span> {{ pritify(item.ShowItemDesc) }}</span>
                                </b-td>
                                <b-td>
                                    <span> {{ pritify(item.ShowOrderingButtons) }}</span>
                                </b-td>
                                <b-td>
                                    <span> {{ pritify(item.Banner) }}</span>
                                </b-td>
                                <b-td>
                                    <span> {{ pritify(item.DisruptiveAds) }}</span>
                                </b-td>
                                <b-td>
                                    <span> {{ pritify(item.Widgets) }}</span>
                                </b-td>
                                <b-td>
                                    <font-awesome-icon icon="pencil-alt" class="align-middle mx-2 cursor-pointer" />
                                </b-td>
                                

                            </b-tr>
                        </b-tbody>
                       
                    </b-table-simple>
                    <b-row v-if="editConfigLoading">
                        <b-col cols="12" class="d-flex justify-content-center align-items-center">
                            <b-spinner variant="primary" label="Saving..."></b-spinner>
                        </b-col>
                    </b-row>
                </b-card>

            <b-container fluid class="p-0">
                <b-card
                    header="Display Ads"
                    header-text-variant="light"
                    header-tag="header"
                    header-class="header-color"
                >
               <b-row>
                    <b-col cols="12" sm="6" md="4" class="mb-4 mb-md-0 text-center text-md-left">
                        <img src="../../../public/img/Display-Ad-Disrupt-Image-con.jpg" class="img mb-2" alt="img">
                        <p>
                            Ad image will intermittently pop up
                            on the screen and be displayed for
                            a duration of about 10 seconds.
                        </p>
                        <b-btn @click="openUploadAdImage()" variant="danger" :disabled="adsDisabled" class="ad-action-btn">
                                Upload Ad Image
                                <font-awesome-icon icon="plus" class="align-middle mx-1"/>
                        </b-btn>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" class="mb-4 mb-md-0 text-center text-md-left">
                        <img src="../../../public/img/Display-Ad-Banner-Icon.jpg" class="img mb-2" alt="img">
                        <p>
                            Banner thumbnails will be continously
                            displayed on the right side of the screen
                            in a shrunk display mode, applicable to
                            horizontal-view displays only.
                        </p>
                        <b-btn @click="openUploadBanner()" variant="danger" :disabled="adsDisabled" class="ad-action-btn">
                                Upload Banner Image
                                <font-awesome-icon icon="plus" class="align-middle mx-1"/>
                        </b-btn>
                        
                    </b-col>
                    <b-col cols="12" sm="6" md="4" class="mb-4 mb-md-0 text-center text-md-left mx-auto">
                        <img src="../../../public/img/Display-Ad-Disrupt-Video-Icons.jpg" class="img mb-2" alt="img">
                        <p>
                            Ad video will intermittently pop up
                            on the screen and be displayed for
                            a max duration of about 15 seconds.
                        </p>
                        <b-btn @click="openUploadAdVideo()" variant="danger" :disabled="true" class="ad-action-btn">
                                Upload Ad Video Link
                                <font-awesome-icon icon="plus" class="align-middle mx-1"/>
                        </b-btn>
                        
                    </b-col>
               </b-row>
               <b-row v-if="adsDisabled">
                    <b-col class="mt-5 text-center">
                        <p class="text-danger mb-0">Your current service subscription does not support advertisement. Contact MENUPOLY customer support to upgrade your service to activate & use ads.</p>
                    </b-col>
               </b-row>
               <b-row class="mt-5">
                <b-table-simple v-if="adsList.length != 0"  striped borderless responsive>
                        <b-thead>
                            <b-tr class="bg-gray-300">
                                <b-th>Ad ID</b-th>
                                <b-th>Image</b-th>
                                <b-th>Ad Type</b-th>
                                <b-th>Start Date</b-th>
                                <b-th>End Date</b-th>
                                <b-th></b-th>
                               
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item,index) in adsList" :key="index" >
                                <b-td @click="showEditMode(item)" class="cursor-pointer">
                                    <span> {{ item.IKey }}</span>
                                </b-td>
                                 <b-td >
                                    <div v-if="item.AdType == 1" class="d-flex justify-content-start align-items-center" style="gap: 10px;">
                                        <div v-if="item.FileType === 'Photo' && item.ThumbFileName != ''"  class="d-flex justify-content-center align-items-center" style="width: 6rem;">
                                            <img @click="showLargeImage = getImage(item.ThumbFileName); showLargeImageMode = true" :style="{height:'60px'}" :src="getImage(item.ThumbFileName)" alt="img">
                                        </div>
                                        <div v-if="!item.ThumbFileName" class="d-flex justify-content-center align-items-center" style="width: 6rem;">
                                            <img @click="showLargeImage = getImage(item.FileName); showLargeImageMode = true" v-if="item.FileType === 'Photo'" :style="{height:'60px'}" :src="getImage(item.FileName)" alt="img">
                                        </div>
                                        <div class="d-flex justify-content-center align-items-center" style="width: 4rem;">
                                            <svg style="height: 60px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><title>Artboard-34</title><g id="Right-2" data-name="Right">
                                                <polygon points="17.5 5.999 16.793 6.706 22.086 11.999 1 11.999 1 12.999 22.086 12.999 16.792 18.294 17.499 19.001 24 12.499 17.5 5.999" style="fill:#232326"/></g>
                                            </svg>
                                        </div>
                                        <div class="d-flex justify-content-center align-items-center" style="width: 6rem;">
                                            <img @click="showLargeImage = getImage(item.FileName); showLargeImageMode = true" v-if="item.FileType === 'Photo'" :style="{height:'60px'}" :src="getImage(item.FileName)" alt="img">
                                        </div>
                                        
                                    
                                    </div>
                                    <div v-if="item.AdType == 2" class="d-flex justify-content-start align-items-center" style="gap: 10px;">
                                        <div class="d-flex justify-content-center align-items-center" style="width: 6rem;">
                                            <img v-if="item.FileType === 'Photo'" @click="showLargeImage = getImage(item.FileName); showLargeImageMode = true" :style="{height:'60px'}" :src="getImage(item.FileName)" alt="img">
                                        </div>
                                    </div>
                                 </b-td>
                                 <b-td @click="showEditMode(item)" class="cursor-pointer">
                                    <span>{{ item.AdType == 1 ? 'Banner Ad Image' : 'Disruptive Ad Image' }}</span>
                                 </b-td>
                                 <b-td @click="showEditMode(item)" class="cursor-pointer">
                                    <span>{{ getDateFormatted(item.StartDate) }}</span>
                                 </b-td>
                                 <b-td @click="showEditMode(item)" class="cursor-pointer">
                                    <span>{{ getDateFormatted(item.EndDate) }}</span>
                                 </b-td>
                                 <b-td @click="showEditMode(item)" class="cursor-pointer">
                                    <font-awesome-icon icon="pencil-alt" class="align-middle mx-2 cursor-pointer" />
                                 </b-td>

                            </b-tr>
                        </b-tbody>
                       
                    </b-table-simple>

               </b-row>
               <b-modal v-model="showLargeImageMode" size="lg" hide-footer hide-header @close="showLargeImage = null; showLargeImageMode = false">
                <div class="d-flex justify-content-center align-items-center">
                    <img :src="showLargeImage" alt="img" class="mb-3" style=" height: 45vh;"></img>
                </div>
               </b-modal>
               <c-modal 
               centered 
               v-model="adImgMode" 
               @submit="uploadAdImage" 
               :progressing="progressing"
               :cancelLabel="adImageType === 'banner' ? 'Never mind, I prefer the default': 'Cancel'  "
               :confirmLabel="adImageType === 'banner' ? 'Upload a different popup image': 'Proceed to Upload'  "
               :tag="false" 
               size="lg" 
               :title="getTitle()"
               @hide="closeAds"
               > 
               <img v-if="adImageType === 'tightAd'" src="../../../public/img/Banner-Sidebar-Icon.jpg" alt="img" class="mb-3" style="width: 100%; height: 100%;">
               <img v-if="adImageType === 'banner' && uploadPopUpImageMode" src="../../../public/img/Banner-Popup-Icon.jpg" alt="img" class="mb-3" style="width: 100%; height: 100%;">
                    <template v-if="adImageType !== 'banner'">
                        <p >Set the period to display this 
                                <span v-if="adImageType === 'tightAd'"> 
                                    Banner.
                                </span>
                                <span v-else>
                                    Ad.
                                </span>
                                </p>
                        <b-row class="d-flex justify-content-center">
                                <p v-if="dateErr === true" :style="{color:'#fc4444 !important'}">End date shall be after start date.</p>

                        </b-row>
                            <b-row class="">
                                
                                <b-col><span class="pr-2">Start Date</span> <input type="date" class="" v-model="startDate" /></b-col>
                                <b-col> <span class="pr-1">End Date</span> <input type="date" v-model="endDate" /> </b-col>
                                
                            </b-row>
                        
                    </template>
                    <template v-else>
                        <p class="px-1"><span class="font-weight-bold">Note:</span> The sidebar imade you uploaded will be used as the default popup image (see above).
                            If you prefer, you can upload <span class="ml-5">a different popup image here.</span></p>
                    </template>

                <upload-photo v-if="uploadPopUpImageMode"
                    title="Upload Banner Pop Up Image"
                    second-content=""
                    v-model="uploadImgMode"
                    :firstContent="'Upload a JPG, PNG, or GIF image file under 10 MB.'"
                    :has-photo="false"
                    :ratio="3/2"
                    @upload="uploadPopUpImage"
                    @delete="deletePhoto"
                    :progressing="progressing"
                    popupMode="true"
                    byPass="true"/>
                <upload-photo v-else-if="adImageType === 'tightAd'"
                    title="Upload Banner Sidebar Image"
                    v-model="uploadImgMode"
                    :firstContent="'Upload a JPG, PNG, or GIF image file under 10 MB.'"
                    :secondContent="'For best results, use an image with a maximum width of 200 pixels and a 1:1, 1:2, or 1:3 aspect ratio.'"
                    :thirdContent="'Recommended sizes:  200 × 200 pixels, 200 × 400 pixels, 200 × 600 pixels'"
                    :has-photo="false"
                    :ratio="1/2"
                    @upload="uploadBanner"
                    @delete="deletePhoto"
                    :progressing="progressing"
                    popupMode="false"
                    byPass="false"/>
                <upload-photo v-else
                    title="Upload Ad Image"
                    second-content="Resolution 1200 by 800 pixel looks best"
                    v-model="uploadImgMode"
                    :has-photo="false"
                    :ratio="3/2"
                    @upload="upload"
                    @delete="deletePhoto"
                    :progressing="progressing"
                    popupMode="false"
                    byPass="false"/>
                
               </c-modal>




               
               <c-modal 
               centered 
               v-model="editAdMode" 
               confirmLabel="Save Changes"
               rejectLabel="Delete Ad"
               cancelLabel="Cancel"
               @submit="editAd" 
               @reject="reject" 
               :tag="false" 
               size="lg" 
               :hasReject="true"
               title="Edit Ad"
               :progressing="progressing"
               >
               <div class="d-flex justify-content-center align-items-center flex-column">

               <p class="center" >Set the period to display this Ad.</p>
               <p v-if="dateErr === true" :style="{color:'#fc4444 !important'}">End date shall be after start date.</p>
               </div>
                <b-row class="pl-5 ml-4">

                    <b-col><span class="pr-2">Start Date</span> <input type="date" class="" v-model="startDate" /></b-col>
                    <b-col> <span class="pr-1">End Date</span> <input :required="true" type="date" v-model="endDate" /> </b-col>
                    
                </b-row>
                </c-modal>

               <c-modal
               centered
               v-model="adVideoMode"
               @submit="submitAdVideoLink"
               :progressing="progressing"
               confirmLabel="Submit"
               cancelLabel="Cancel"
               :tag="false"
               size="lg"
               title="Upload Ad Video Address"
               @hide="setDates(); videoLink = ''; videoLinkErr = false"
               >
                    <p>Set the period to display this Ad.</p>
                    <b-row class="d-flex justify-content-center">
                        <p v-if="dateErr === true" :style="{color:'#fc4444 !important'}">End date shall be after start date.</p>
                    </b-row>
                    <b-row class="mb-4">
                        <b-col><span class="pr-2">Start Date</span> <input type="date" v-model="startDate" /></b-col>
                        <b-col> <span class="pr-1">End Date</span> <input type="date" v-model="endDate" /> </b-col>
                    </b-row>
                    <p>
                        Upload your video (MP4, MPG, or MOV format) to an online storage service (Google Drive, Dropbox, etc.)
                        and make sure the file or folder is either set to "Public" or shared directly with
                        customersupport@menupoly.com. Then copy and past the video link into the field below.
                    </p>
                    <label class="mb-1 font-weight-bold">Video File Link</label>
                    <b-form-input placeholder="Required" v-model="videoLink" :state="videoLinkErr ? false : null"/>
                    <small v-if="videoLinkErr" class="text-danger d-block mt-1">Please enter a valid video link.</small>
                    <p class="mt-3 mb-0"><span class="font-weight-bold">Note:</span> Make sure your video is in standard MP4 format and no longer than 25 seconds.</p>
               </c-modal>
                
                </b-card>
            </b-container>
            <c-modal 
               centered 
               v-model="editConfigMode" 
               confirmLabel="Save Changes"
               cancelLabel="Cancel"
               @submit="editConfig"
               @cancel="cancelEditConfig"
               :tag="false" 
               size="lg" 
               title="Edit Menu Display Configurations"
               :progressing="progressing"
                >
                <b-container class="px-2 px-md-5 edit-config-body">
                    <b-row>
                        <b-col cols="12" md="6" class="mb-2 mb-md-0">
                            <p> <span class="font-weight-bold">Asset Name:</span>  {{ selectedKioskConfig.AssetName }}</p>
                        </b-col>
                        <b-col cols="12" md="6">
                            <p> <span class="font-weight-bold">Asset Category:</span> {{ selectedKioskConfig.AssetCategory }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="6">
                            <Mlabel title="Display Theme" class="mt-2">
                                {{ selectedKioskConfig.Theme }}
                                
                                <b-link class="ml-2 mb-2" v-if="!showChangeTheme " @click="changeShowTheme()"> Edit</b-link>
                                                
                                        <b-input-group prepend="Display Theme" v-if="showChangeTheme" >
                                    <b-form-select
                                    class="myFeild"
                                    v-model="selectedKioskConfig.Theme"
                                    :options="['V Classic Light 1', 'H Classic Light 1']"
                                    placeholder="Select"
                                    >
                                    <template #first>
                                        <b-form-select-option :value="null||''">Select...</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                </b-input-group>
                                </Mlabel>
                        </b-col>
                    </b-row>
                    <b-row class="mt-5 position-relative">
                        <p class="font-weight-bold show-hide-label" style="background-color: #fff;" @click="toggleButtons">
                            <span >Show Or Hide</span>
                        </p>
                        <b-container class="dashed-box pl-3 mt-2" v-if="buttonsVisible">
                            
                            
                            <b-row class="mb-4 mt-4">
                                <b-col cols="12" md="4" class="d-flex justify-content-start align-items-center mb-3 mb-md-0">
                                    <p class="mr-2 mt-3 font-weight-bold">Food Menu:</p>
                                    <c-switch
                                            color="warning"
                                            v-model="kioskFoodMenu"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </b-col>
                                
                                <b-col cols="12" md="4" class="d-flex justify-content-start align-items-center mb-3 mb-md-0">
                                    <p class="mr-5 mt-3 font-weight-bold">Item Price:</p>
                                    <c-switch
                                            color="warning"
                                            v-model="selectedKioskConfig.ShowPrice"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </b-col>
                                <b-col cols="12" md="4" class="d-flex justify-content-start align-items-center"> 
                                    <p class="mr-4 mt-3 font-weight-bold">Banners Ads:</p>
                                    <c-switch
                                            color="warning"
                                            v-model="selectedKioskConfig.Banner"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </b-col>
                                 
                            </b-row>
                            <b-row class="my-4">
                                <b-col cols="12" md="4" class="d-flex justify-content-start align-items-center mb-3 mb-md-0">
                                    <p class="mr-2 mt-3 font-weight-bold">Drink Menu:</p>
                                    <c-switch
                                            color="warning"
                                            v-model="kioskDrinkMenu"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </b-col>
                                <b-col cols="12" md="4" class="d-flex justify-content-start align-items-center mb-3 mb-md-0">
                                    <p class="mr-1 mt-3 font-weight-bold">Item Description:</p>
                                    <c-switch
                                    class="ml-1"
                                            color="warning"
                                            v-model="selectedKioskConfig.ShowItemDesc"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </b-col>
                                <b-col cols="12" md="4" class="d-flex justify-content-start align-items-center"> 
                                    <p class="mr-2 mt-3 font-weight-bold">Disruptive Ads:</p>
                                    <c-switch
                                    class="ml-1"
                                            color="warning"
                                            v-model="selectedKioskConfig.DisruptiveAds"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </b-col>
                            </b-row>
                            <b-row class="mb-4">
                                <b-col cols="12" md="4" class="d-none d-md-block"></b-col>
                                <b-col cols="12" md="4" class="d-flex justify-content-start align-items-center mb-3 mb-md-0">
                                    <p class="mr-1 mt-3 font-weight-bold">Ordering Buttons:</p>
                                    <c-switch
                                    class="ml-1"
                                            color="warning"
                                            v-model="selectedKioskConfig.ShowOrderingButtons"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </b-col>
                                <b-col cols="12" md="4" class="d-flex justify-content-start align-items-center">
                                    <p class="mr-1 mt-3 font-weight-bold">Widgets:</p>
                                    <c-switch
                                    class="ml-5"
                                            color="warning"
                                            v-model="selectedKioskConfig.Widgets"
                                            label variant="3d"  dataOn="on" dataOff="off"/>
                                </b-col>
                                
                            </b-row>
                            
                        </b-container>
                        <b-row class="mt-5 pl-3">
                            <b-col cols="12">
                            <p v-if="!showChangeDisplayMode"> <span class="font-weight-bold">Available Display Modes:</span>  {{ selectedKioskConfig.AvailableDisplayModes }} <b-link class="ml-2 mb-2"  @click="changeShowDisplayMode()"> Edit</b-link> </p>
                            <p v-else> <span class="font-weight-bold">Available Display Modes:</span> </p>
                                <div v-if="showChangeDisplayMode" class="p-4" style="border: 1px solid #ccc;padding: 10px;border-radius: 5px;">
                                    <div>
                                        <p style="display: inline-block;margin-right: 10px; background-color: #4dbd74;color: #fff;padding: 0.75rem 1.5rem; padding-left: 0.75rem;border-radius: 5px; position: relative;" v-for="item in selectedDisplayModes" :key="item">
                                            <font-awesome-icon v-if="selectedDisplayModes && selectedDisplayModes.length > 1" icon="times" class="align-middle mr-3 cursor-pointer" @click="removeDisplayMode(item)"/>
                                            {{ item }}
                                        </p>

                                    </div>
                                   <b-row>
                                    
                                    <div class="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center display-mode-picker">
                                        <b-form-select
                                        class="myFeild mr-sm-2 mb-2 mb-sm-0"
                                        @change="addDisplayMode($event)"
                                        :options="availableDisplayModes"
                                        placeholder="Select"
                                        >
                                        <template #first>
                                            <b-form-select-option :value="null||''">Select...</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <b-btn variant="success" @click="saveDisplayMode()">Save</b-btn>
                                    </div>
                                   </b-row>
                                </div>
                            </b-col>
                            
                            
                        </b-row>
                        
                        <b-container>
                            <b-row>
                                <b-col cols="12" md="6">
                                    
                                    <b-input-group prepend="Display Mode At Bootup"  class="mt-2">
                                        <b-form-select
                                        class="myFeild"
                                        v-model="selectedKioskConfig.BootupDisplayMode"
                                        :options="getSelectedDisplayModes()"
                                        placeholder="Select"
                                        >
                                        <template #first>
                                            <b-form-select-option :value="null||''">Select...</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                        </b-container>

                        <b-container class="mb-3 mt-4">
                            <b-row>
                                <b-col cols="12" md="7">
                                    <b-input-group prepend="Default Display Language At Bootup"  class="mt-2">
                                        <b-form-select
                                        class="myFeild"
                                        v-model="defaultKioskLanguage"
                                        :options="languages"
                                        placeholder="Select"
                                        >
                                        <template #first>
                                            <b-form-select-option :value="null||''">Select...</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-row>

                </b-container>
            </c-modal>
        </b-overlay>
    </div>
</template>


<script>
import CModal from "../shared/Cmodal";
import UploadPhoto from "../shared/UploadPhoto.vue";
import config from "SrcConfig";
import Mlabel from "../shared/Mlabel";
import { Switch as cSwitch } from '@/components/shared'

export default {
name:'menuDisplay',
components:{
    CModal,
    UploadPhoto,
    cSwitch,
    Mlabel,
},
data(){
    return{
        loading:false,
        adsList:[],
        adImgMode:false,
        uploadImgMode:false,
        adBannerMode:false,
        startDate:"",
        endDate:"",
        adImageType:"",
        progressing:false,
        editAdMode:false,
        editConfigMode:false,
        selectedKioskConfig:{},
        selectedConfigID:"",
        selectedAdID:"",
        dateErr:false,
        adTitle:false,
        baseURL:"",
        kioskConfigList:[],
        buttonsVisible:true,
        showChangeBootup:false,
        showChangeTheme:false,
        showChangeDisplayMode:false,
        availableDisplayModes:[],
        availableDisplayModesReference:[],
        selectedDisplayModes:[],
        kioskFoodMenu:false,
        kioskDrinkMenu:false,
        editConfigLoading:false,
        uploadPopUpImageMode:false,
        proceedToUploadPopupImage:true,
        showLargeImage:null,
        showLargeImageMode:false,
        languagesReference:[],
        languages:[],
        adsEnabled:1,
        adVideoMode:false,
        videoLink:"",
        videoLinkErr:false,
    }
},
computed:{
    adsDisabled(){
        return Number(this.adsEnabled) === 0
    }
},

created(){
    let url = window.location.href
    url = url.substring(0,url.indexOf('.')+1)
    if(config.files.baseurlimage.search('www') != -1){
        this.baseURL = 'https://images.menupoly.com/KioskAds/'
    }else{
        this.baseURL = config.files.baseurlimage + '/KioskAds/'
    }

    this.getKioskDisplayModes()
    this.getKioskConfig()
    this.getAds()
    this.setDates()
    this.getLanguages()
    this.getRestaurantAdsEnabled()
},

methods:{
    getRestaurantAdsEnabled(){
        this.$api.publicClient.GetRestaurantInfo({RestaurantID:this.$store.state.selectedRestaurantId}).then(res=>{
            if(res.success){
                console.log(res.results)
                this.adsEnabled = res.results.AdsEnabled
            }
        })
    },
    openUploadAdVideo(){
        this.setDates()
        this.videoLink = ""
        this.videoLinkErr = false
        this.adVideoMode = true
    },
    submitAdVideoLink(){
        this.dateErr = new Date(this.startDate) > new Date(this.endDate)
        const link = this.videoLink.trim()
        this.videoLinkErr = !/^https?:\/\/\S+\.\S+/i.test(link)
        if(this.dateErr || this.videoLinkErr) return

        const [businessName, ...addressParts] = (localStorage.getItem("selectedRestaurantName") || "").split("|").map(part => part.trim())
        const userName = [localStorage.getItem("name"), localStorage.getItem("lastName")].filter(Boolean).join(" ")
        const subject = "Disruptive Ad Video Link Submission"
        const message = [
            `Subject: ${subject}`,
            "",
            `Business Name: ${businessName || ""}`,
            `Business Address: ${addressParts.join(", ")}`,
            `Business ID: ${this.$store.state.selectedRestaurantId}`,
            `Name of User submitted: ${userName}`,
            `Start Date: ${this.startDate}`,
            `End Date: ${this.endDate}`,
            `Video Link: ${link}`,
        ].join("\n")

        this.progressing = true
        this.$api.getRestaurant.CustomerSupport({
            RestaurantID: this.$store.state.selectedRestaurantId,
            ClientID: localStorage.getItem("restaurantProfile"),
            Subject: subject,
            Message: message,
        }).then(res=>{
            if(res.success){
                this.$showSuccess("Your video link has been submitted to MENUPOLY customer support.")
                this.adVideoMode = false
            }else{
                this.$showError(res.message)
            }
        }).finally(()=>{
            this.progressing = false
        })
    },
    getLanguages(){
        let model = {
            RestaurantID: this.$store.state.selectedRestaurantId,
            UserID: localStorage.getItem('userID')
        }
        this.$api.getRestaurant.GetKioskLanguage(model).then(res=>{
            if(res.success){
                
                this.languagesReference = res.results
                this.languages = this.languagesReference.map(item => item[1])
            }
        })
    },
    closeAds(){
      this.reset()
      this.getAds()
    },
    getTitle(){
        if(this.adImageType === 'tightAd'){
            return 'Upload Banner Sidebar Image'
        }else if(this.adImageType === 'banner' ){
            return 'Upload Banner Pop Up Image'
        }else if(this.adImageType === 'wideAd'){
            return 'Upload Ad Image'
        }
    },
    getImage(fileName){
        let baseUrl = config.files.baseurlimage;
        if (config.files.baseurlimage.search('www') != -1) {
            return "https://images.menupoly.com"+ `/KioskAds/` + fileName
        }
        return baseUrl + `/KioskAds/` + fileName
    },
    getKioskDisplayModes(){
        this.$api.getRestaurant.GetKioskDisplayMode().then(res=>{
            if(res.success){
                this.availableDisplayModesReference = res.roles
                this.availableDisplayModes = this.availableDisplayModesReference.map(item => item.DisplayMode)
            }
        })
    },
    editConfig(){
        this.progressing = true
        let model = {}
        model.RestaurantID = this.$store.state.selectedRestaurantId
        model.UserID = localStorage.getItem('userID')
        model.KioskID = this.selectedKioskConfig.KioskID
        model.Theme = this.selectedKioskConfig.Theme
        model.ShowPrice = this.selectedKioskConfig.ShowPrice ? 1 : 0
        model.ShowItemDesc = this.selectedKioskConfig.ShowItemDesc ? 1 : 0
        model.ShowDisruptiveAds = this.selectedKioskConfig.DisruptiveAds ? 1 : 0
        model.ShowWidgets = this.selectedKioskConfig.Widgets ? 1 : 0
        model.ShowBanner = this.selectedKioskConfig.Banner ? 1 : 0
        console.log(this.defaultKioskLanguage)
        if(this.defaultKioskLanguage == undefined || this.defaultKioskLanguage == null || this.defaultKioskLanguage == ""){
            this.defaultKioskLanguage = "English"
        }
        model.DefaultKioskLanguage = this.languagesReference.find(item => item[1] == this.defaultKioskLanguage)[0] 
        if(this.selectedKioskConfig.BootupDisplayMode != "" && this.selectedDisplayModes.length == 0){
            model.BootupDisplayMode = "Snaps View"
        }else if(this.selectedKioskConfig.BootupDisplayMode == "" && this.selectedDisplayModes.length == 0){
            model.BootupDisplayMode = "Snaps View"
        }else if(this.selectedDisplayModes.length == 1){
            model.BootupDisplayMode = this.selectedDisplayModes[0]
        }else if(this.selectedDisplayModes.length > 1){
            let found = this.availableDisplayModes.find(item => item == this.selectedKioskConfig.BootupDisplayMode)
            if(found){
                model.BootupDisplayMode = this.selectedKioskConfig.BootupDisplayMode
            }else{
                model.BootupDisplayMode = this.availableDisplayModes[0]
            }
        }else{
            model.BootupDisplayMode = this.selectedKioskConfig.BootupDisplayMode
        }
        
        model.ShowOrderingButtons = this.selectedKioskConfig.ShowOrderingButtons ? 1 : 0
        
        model.ItemForShow = ""
        if(this.kioskFoodMenu && !this.kioskDrinkMenu){
            model.ItemForShow = model.ItemForShow + "Food"
        }
        if(this.kioskDrinkMenu && !this.kioskFoodMenu){
            model.ItemForShow = model.ItemForShow + "Drink"
        }
        if(this.kioskFoodMenu && this.kioskDrinkMenu){
            model.ItemForShow = model.ItemForShow + "Food & Drink"
        }
        if(!this.kioskFoodMenu && !this.kioskDrinkMenu){
            model.ItemForShow = ""
        }
        if(this.selectedDisplayModes.length != 0){
            model.AvailableDisplayModes = ""
            this.selectedDisplayModes.forEach(item => {
                model.AvailableDisplayModes = model.AvailableDisplayModes + "," + this.availableDisplayModesReference.find(i => i.DisplayMode === item).DisplayModeID

            })
            if(model.AvailableDisplayModes == ""){
                model.AvailableDisplayModes = "1"
            }else{
            model.AvailableDisplayModes = model.AvailableDisplayModes.substring(1)
            }
        }else{
            model.AvailableDisplayModes = "1"
        }
        
        this.$api.getRestaurant.UpdateKioskConfig(model).then(()=>{
            this.progressing = false
        })
        this.editConfigMode = false
        this.editConfigLoading = true
        setTimeout(()=>{
            this.getKioskConfig()
            this.editConfigLoading = false
        },1000)
    },
    getSelectedDisplayModes(){
        if(this.selectedKioskConfig.AvailableDisplayModes != "" && this.selectedKioskConfig.AvailableDisplayModes != null && this.selectedKioskConfig.AvailableDisplayModes != undefined){
            return this.selectedKioskConfig.AvailableDisplayModes.split(',').map(item => item.trim())
        }else{
            return []
        }
    },
    saveDisplayMode(){
        if(this.selectedDisplayModes.length > 0){   
            this.selectedKioskConfig.AvailableDisplayModes = this.selectedDisplayModes.join(',')
        }else{
            this.selectedKioskConfig.AvailableDisplayModes = ""
        }
        this.showChangeDisplayMode = false

        if(this.selectedKioskConfig.AvailableDisplayModes != ""){
            let availableDisplayModes = this.getSelectedDisplayModes()
            if(availableDisplayModes.find(item => item == this.selectedKioskConfig.BootupDisplayMode) == undefined && availableDisplayModes.length > 0){
                this.selectedKioskConfig.BootupDisplayMode = availableDisplayModes[0]
            }
        }else{
            this.selectedKioskConfig.BootupDisplayMode = ""
        }
    
    },
    removeDisplayMode(item){
        if(this.selectedKioskConfig.AvailableDisplayModes.length == 1){
            return
        }
        this.selectedDisplayModes = this.selectedDisplayModes.filter(mode => mode !== item)
    },
    addDisplayMode(e){
        let found = this.selectedDisplayModes.find(item => item === e)
        if(!found && e !== null && e !== "" && e !== undefined){
            this.selectedDisplayModes.push(e)
        }
    },
    changeShowDisplayMode(){
        this.selectedDisplayModes = this.selectedKioskConfig.AvailableDisplayModes ? this.selectedKioskConfig.AvailableDisplayModes.split(',').map(item => item.trim()) : []
        this.showChangeDisplayMode = !this.showChangeDisplayMode
    },
    cancelEditConfig(){
        this.editConfigMode = false
        this.showChangeTheme = false
    },
    changeShowTheme(){
        this.showChangeTheme = !this.showChangeTheme
    },
    
    changeBootupVisibility(){
        this.showChangeBootup = !this.showChangeBootup
    },
    toggleButtons(){
        this.buttonsVisible = !this.buttonsVisible
    },
    showEditConfigMode(item){
        this.showChangeDisplayMode = false
        this.showChangeTheme = false
        this.loading = true
        this.editConfigMode = true
        this.selectedConfigID = item.KioskID
        this.$api.getRestaurant.GetDisplayConfigs({RestaurantID:this.$store.state.selectedRestaurantId,KioskID:this.selectedConfigID}).then(res=>{
            if(res.success){
                this.selectedKioskConfig = res.data[0]
                this.selectedDisplayModes = this.selectedKioskConfig.AvailableDisplayModes ? this.selectedKioskConfig.AvailableDisplayModes.split(',').map(item => item.trim()) : []

                this.loading = false
                if(this.selectedKioskConfig.ItemForShow.includes("Food")){
                    this.kioskFoodMenu = true
                }else{
                    this.kioskFoodMenu = false
                }
                if(this.selectedKioskConfig.ItemForShow.includes("Drink")){
                    this.kioskDrinkMenu = true
                }else{
                    this.kioskDrinkMenu = false
                }
                if(this.languagesReference.length > 0){
                    this.defaultKioskLanguage = this.languagesReference.find(item => item[0] == this.selectedKioskConfig.DefaultKioskLanguage)[1]
                }
            }
        })
    },
    getKioskConfig(){
        
        this.$api.getRestaurant.GetDisplayConfigs({RestaurantID:this.$store.state.selectedRestaurantId,KioskID:-1}).then(res=>{
            if(res.success){
                this.kioskConfigList = []
                this.kioskConfigList = res.data
            }
        })
    },
    setDates(){
        this.dateErr = false
        const today = new Date();
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months start at 0!
        let dd = today.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        const formattedToday = yyyy + '-' + mm + '-' + dd;
        this.startDate = formattedToday
        this.endDate = formattedToday
    },
    reject(){
        this.deleteAd()
    },
    pritify(value){
        return value ? 'Yes' : 'No'
    },
    openUploadAdImage(){
        this.setDates()
        this.adImgMode=true
        this.adImageType = 'wideAd' 
        this.adTitle = 'Ad'
    },
    openUploadBanner(){
        this.setDates()
        this.adImgMode=true
        this.adImageType = 'tightAd'
        this.adTitle = 'Banner'
    },
    getDateFormatted(dateString){
                if(typeof(dateString) != "string" || dateString.length === 0){
                    return
                }
                
                const monthsArr = 
                ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                let date =  dateString.substring(0,dateString.indexOf(" "))
                date = date.split("/")
                let finalDate = "" +date[1]+ "-" + monthsArr[date[0].toString() -1]+ "-" + date[2]
                return finalDate


            },
    uploadPopUpImage(data){
        this.progressing = true
        let imgData = data

        let indexOfColon = data.image.indexOf(",")
        
        imgData.image =  imgData.image.substring(indexOfColon+1,imgData.image.length)

        

        
         let model = {
            RestaurantID: Number(this.$store.state.selectedRestaurantId),
            EndDate: this.endDate,
            StartDate: this.startDate,
            AdImageType:this.adImageType,
            DurationSecond:15,
            File:imgData.image,
            AdsID:this.selectedAdID
         }
         this.$api.getRestaurant.CreateRestaurantAd(model).then(res=>{
            if(res.success){               
                    this.reset()
                    this.getAds()
            }
            this.progressing = false
         })
         this.uploadImgMode = false
        this.uploadPopUpImageMode = false
        
    },
    uploadBanner(data){
        this.progressing = true
        let imgData = data

        let indexOfColon = data.image.indexOf(",")
        
        imgData.image =  imgData.image.substring(indexOfColon+1,imgData.image.length)

        

        
         let model = {
            RestaurantID: Number(this.$store.state.selectedRestaurantId),
            EndDate: this.endDate,
            StartDate: this.startDate,
            AdImageType:this.adImageType,
            DurationSecond:15,
            File:imgData.image,
            AdsID:0//to create new ad
         }
         this.$api.getRestaurant.CreateRestaurantAd(model).then(res=>{
            if(res.success){
                this.selectedAdID = res.AdsID
                if( !this.proceedToUploadPopupImage){
                    this.reset()
                    this.getAds()
                }
            }
            this.progressing = false
         })
         
             this.uploadImgMode=false
             if(this.proceedToUploadPopupImage){
                this.uploadPopUpImageMode = true
                this.adImageType = 'banner'
         }
        },
    upload(data){
        this.progressing = true
        let imgData = data

        let indexOfColon = data.image.indexOf(",")
        
        imgData.image =  imgData.image.substring(indexOfColon+1,imgData.image.length)

        

        
         let model = {
            RestaurantID: Number(this.$store.state.selectedRestaurantId),
            EndDate: this.endDate,
            StartDate: this.startDate,
            AdImageType:this.adImageType,
            DurationSecond:15,
            File:imgData.image,
            AdsID:0
         }
         this.$api.getRestaurant.CreateRestaurantAd(model).then(res=>{
            if(res.success){

                this.reset()
                this.getAds()
            }
            this.progressing = false
         })
         this.uploadImgMode=false
    },
    editAd(){
        let date = new Date(this.startDate)
        let date2 = new Date(this.endDate)
        if(date <= date2){
             this.dateErr = false
        }else{
            return this.dateErr = true
        }
        this.progressing = true
        let model = {
            AdID:this.selectedAdID,
            StartDate: this.startDate,
            EndDate: this.endDate
        }
        this.$api.getRestaurant.UpdateRestaurantAd(model).then(()=>{
            this.progressing = false
            this.editAdMode = false
            this.getAds()
        })
    
    },
    reset(){
        this.setDates()
        this.adImgMode = false
        this.adImageType = ""
        this.adBannerMode = false
        this.uploadPopUpImageMode = false
        this.selectedAdID = null
        this.uploadPopUpImageMode=false
        this.proceedToUploadPopupImage=true
    },
    showEditMode(item){
        this.editAdMode = true
        let startDate = this.getDateFormatted(item.StartDate).split("-")
        //let startDateFromatted 
        let endDate = this.getDateFormatted(item.EndDate).split("-")
        //let endDateFromatted

        const monthsArr = 
                ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        startDate[1] = monthsArr.indexOf(startDate[1]) + 1
       
        endDate[1] = monthsArr.indexOf(endDate[1]) + 1
        if(parseInt(startDate[1]) < 10){
            startDate[1] = "0" + startDate[1]
        }
        if(parseInt(endDate[1]) < 10){
            endDate[1] = "0" + endDate[1]
        }
        if(parseInt(startDate[0]) < 10){
            startDate[0] = "0" + startDate[0]
        }
        if(parseInt(endDate[0]) < 10){
            endDate[0] = "0" + endDate[0]
        }
        this.startDate = startDate[2] + "-" + startDate[1] + "-" + startDate[0]
        this.endDate   =   endDate[2] + "-" +   endDate[1] + "-" +   endDate[0]
        this.selectedAdID = item.IKey
        
    },
    deletePhoto(){
        return
    },
    uploadAdImage(){
        let date = new Date(this.startDate)
        let date2 = new Date(this.endDate)
        if(date <= date2){
            this.dateErr = false
            return this.uploadImgMode = true
        }
        return this.dateErr = true
    },
    createAdimage(info){
        let model = {
            RestaurantID: this.$store.state.selectedRestaurantId,
            StartDate:info.startDate,
            EndDate:info.endDate,
            AdImageType:info.adType,
            DurationSecond:info.duration,
            File:info.file
        }
        this.$api.getRestaurant.CreateRestaurantAd(model).then(res=>{
            this.getAds()
        })
        
    },
   
    
    deleteAd(){
        this.progressing = true
        let model = {
            RestaurantID:this.$store.state.selectedRestaurantId,
            AdID:this.selectedAdID
        }
        this.$api.getRestaurant.DeleteRestaurantAd(model).then(()=>{
            this.getAds()
            this.progressing = false
            this.editAdMode = false
        })
    },
    getAds(){
        this.dateErr = false
        this.$api.getRestaurant.GetRestaurantAds({RestaurantID:this.$store.state.selectedRestaurantId,AdID:-1}).then(res=>{
            if(res.success)
                this.adsList = res.RestaurantAds
            
        })
    },
    
    hideAddTV(){
        this.addTvMode = false
        this.newTVmodel = {
            TVid:0,
            TVname:"",
            BackgroundColor:"#ffffff",
            Category_FontName:"Oswald",
            Category_FontStyle:"Underlined",
            Category_FontSize:15,
            Category_FontColor:"#000000",
            CategoryComm_FontName:"Oswald",
            CategoryComm_FontStyle:"Italic",
            CategoryComm_FontSize:13,
            CategoryComm_FontColor:"#B2BEB5",
            Food_FontName:"Roboto",
            Food_FontStyle:"Normal",
            Food_FontSize:12,
            Food_FontColor:"#000000"}
    },
    

}
}
</script>

<style lang="css">
.dashed-box {
    background-image: repeating-linear-gradient(-28deg, #333333, #333333 19px, transparent 19px, transparent 28px, #333333 28px), repeating-linear-gradient(62deg, #333333, #333333 19px, transparent 19px, transparent 28px, #333333 28px), repeating-linear-gradient(152deg, #333333, #333333 19px, transparent 19px, transparent 28px, #333333 28px), repeating-linear-gradient(242deg, #333333, #333333 19px, transparent 19px, transparent 28px, #333333 28px);
background-size: 2px 100%, 100% 2px, 2px 100% , 100% 2px;
background-position: 0 0, 0 0, 100% 0, 0 100%;
background-repeat: no-repeat;

}
.img{
    width: 100%;
    max-width: 15rem;
    height: auto;
    aspect-ratio: 15 / 9;
    object-fit: cover;
}
@media (max-width: 575.98px){
    .img{
        max-width: 12rem;
    }
}
@media (min-width: 1200px){
    .img{
        max-width: 17rem;
    }
}
.ad-action-btn{
    width: 100%;
}
@media (min-width: 768px){
    .ad-action-btn{
        width: auto;
    }
}
.show-hide-label{
    position: absolute;
    top: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 1.4rem;
    white-space: nowrap;
    cursor: pointer;
}
.display-mode-picker{
    width: 100%;
}
.display-mode-picker .myFeild{
    width: 100%;
}
@media (min-width: 576px){
    .display-mode-picker{
        width: auto;
    }
    .display-mode-picker .myFeild{
        min-width: 12rem;
        width: auto;
    }
}
@media (max-width: 575.98px){
    .show-hide-label{
        font-size: 1.1rem;
    }
    .edit-config-body .input-group{
        flex-wrap: wrap;
    }
    .edit-config-body .input-group-prepend{
        width: 100%;
        margin-bottom: 0.25rem;
    }
    .edit-config-body .input-group-prepend .input-group-text{
        width: 100%;
    }
    .edit-config-body .input-group > select,
    .edit-config-body .input-group > .custom-select{
        flex: 1 1 100%;
        width: 100%;
    }
}
.header-color {
  background-color: #3f4d5a;
}
#color{
height: 2.2rem;
}
.backgroundColor{
height: 2.2rem;
width: 6rem;
}

</style>